import ARCORequest from './ARCORequest';
import CookiesPolicy from './CookiesPolicy';
import MembershipPolicy from './MembershipPolicy';
import PAYGPolicy from './PAYGPolicy';
import PrivacyNoticeCo from './PrivacyNoticeCo';
import PrivacyNoticeMx from './PrivacyNoticeMx';
import PrivacyPolicy from './PrivacyPolicy';
import PrivacyPolicyBr from './PrivacyPolicyBr';
import RefundPolicy from './RefundPolicy';
import SecurityPrivacyPolicy from './SecurityPrivacyPolicy';
import { SLA } from './SLA';
import TeacherAgreement from './TeacherAgreement';
import TermsAndConditions from './TermsAndConditions';
import TermsAndConditionsB2B from './TermsAndConditionsB2B';
import TermsAndConditionsBRB2B from './TermsAndConditionsBRB2B';
import TermsAndConditionsENB2B from './TermsAndConditionsENB2B';

export interface Route {
  key: string;
  path: string;
  exact: boolean;
  component: any;
  updatedAt: string;
}

export const BASE_URL = '/legal';

export const TERMS_AND_CONDITIONS_ROUTE = {
  key: 'TERMS_AND_CONDITIONS',
  path: '/terminos-y-condiciones/',
  exact: true,
  component: TermsAndConditions,
  updatedAt: '6 de Mayo de 2021',
};

export const TERMS_AND_CONDITIONS_B2B_ROUTE = {
  key: 'TERMS_AND_CONDITIONS_B2B',
  path: '/terminos-y-condiciones-b2b/',
  exact: true,
  component: TermsAndConditionsB2B,
  updatedAt: '16 de Febrero de 2022',
};

export const TERMS_AND_CONDITIONS_B2B_EN_ROUTE = {
  key: 'TERMS_AND_CONDITIONS_B2B_EN',
  path: '/terms-and-conditions-b2b/',
  exact: true,
  component: TermsAndConditionsENB2B,
  updatedAt: '01 de Abril de 2022',
};

export const TERMS_AND_CONDITIONS_B2B_BR_ROUTE = {
  key: 'TERMS_AND_CONDITIONS_B2B_BR',
  path: '/terminos-y-condiciones-b2b-br/',
  exact: true,
  component: TermsAndConditionsBRB2B,
  updatedAt: '30 de Mayo de 2022',
};

export const PRIVACY_ROUTE = {
  key: 'PRIVACY',
  path: '/politicas-de-privacidad/',
  exact: false,
  component: PrivacyPolicy,
  updatedAt: '20 de Mayo de 2022',
};

export const PRIVACY_BR_ROUTE = {
  key: 'PRIVACY_BR',
  path: '/politicas-de-privacidad-br/',
  exact: false,
  component: PrivacyPolicyBr,
  updatedAt: '24 de Mayo de 2022',
};

export const PRIVACY_PE_ROUTE = {
  key: 'PRIVACY_PE',
  path: '',
};

export const PRIVACY_CO_ROUTE = {
  key: 'PRIVACY_CO',
  path: 'co/',
};

export const PRIVACY_CL_ROUTE = {
  key: 'PRIVACY_CL',
  path: 'cl/',
};

export const PRIVACY_MX_ROUTE = {
  key: 'PRIVACY_MX',
  path: 'mx/',
};

export const PRIVACY_ROUTES = [
  PRIVACY_PE_ROUTE,
  PRIVACY_CO_ROUTE,
  PRIVACY_CL_ROUTE,
  PRIVACY_MX_ROUTE,
];

export const PRIVACY_NOTICE_MX_ROUTE = {
  key: 'PRIVACY_NOTICE_MX',
  path: '/avisos-de-privacidad/mx/',
  exact: true,
  component: PrivacyNoticeMx,
  updatedAt: 'Mayo de 2020',
};

export const PRIVACY_NOTICE_CO_ROUTE = {
  key: 'PRIVACY_NOTICE_CO',
  path: '/avisos-de-privacidad/co/',
  exact: true,
  component: PrivacyNoticeCo,
  updatedAt: '20 de Julio de 2020',
};

export const MEMBERSHIP_POLICY_ROUTE = {
  key: 'MEMBERSHIP_POLICY',
  path: '/politicas-de-membresias/',
  exact: false,
  component: MembershipPolicy,
  updatedAt: '20 de Julio de 2020',
};

export const PAYG_POLICY_ROUTE = {
  key: 'PAYG_POLICY',
  path: '/politicas-de-payg/',
  exact: true,
  component: PAYGPolicy,
  updatedAt: '20 de Julio de 2020',
};

export const TEACHER_AGREEMENT_ROUTE = {
  key: 'TEACHER_AGREEMENT',
  path: '/acuerdo-para-profesores/',
  exact: true,
  component: TeacherAgreement,
  updatedAt: '01 de Junio de 2022',
};

export const COOKIES_POLICY_ROUTE = {
  key: 'COOKIES_POLICY',
  path: '/politica-de-cookies/',
  exact: true,
  component: CookiesPolicy,
  updatedAt: '20 de Julio de 2020',
};

export const ARCO_ROUTE = {
  key: 'ARCO_REQUEST',
  path: '/solicitud-arco/',
  exact: true,
  component: ARCORequest,
  updatedAt: '20 de Julio de 2020',
};

export const REFUND_POLICY_ROUTE = {
  key: 'REFUND_POLICY',
  path: '/politicas-de-reembolso/',
  exact: true,
  component: RefundPolicy,
  updatedAt: '16 de Diciembre de 2020',
};

export const SECURITY_AND_PRIVACY_POLICY_ROUTE = {
  key: 'SECURITY_AND_PRIVACY_POLICY',
  path: '/politicas-de-seguridad-y-privacidad/',
  exact: true,
  component: SecurityPrivacyPolicy,
  updatedAt: '18 de Octubre de 2021',
};

export const SLA_ROUTE = {
  key: 'SLA',
  path: '/service-level-agreement',
  exact: true,
  component: SLA,
  updatedAt: '05 de Abril de 2023',
};

const ROUTES: Route[] = [
  TERMS_AND_CONDITIONS_ROUTE,
  PRIVACY_ROUTE,
  PRIVACY_BR_ROUTE,
  PRIVACY_NOTICE_MX_ROUTE,
  PRIVACY_NOTICE_CO_ROUTE,
  // PRIVACY_NOTICE_CO_ROUTE,
  MEMBERSHIP_POLICY_ROUTE,
  PAYG_POLICY_ROUTE,
  TEACHER_AGREEMENT_ROUTE,
  COOKIES_POLICY_ROUTE,
  ARCO_ROUTE,
  REFUND_POLICY_ROUTE,
  SECURITY_AND_PRIVACY_POLICY_ROUTE,
  TERMS_AND_CONDITIONS_B2B_ROUTE,
  TERMS_AND_CONDITIONS_B2B_EN_ROUTE,
  TERMS_AND_CONDITIONS_B2B_BR_ROUTE,
  SLA_ROUTE,
];

export default ROUTES;
